import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

class LogoutDialog extends React.Component {
  render() {
    const {
      t,
      isOpen,
      onClose,
      onConfirm,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="logout-dialog-title"
        className="logout-dialog"
      >
        <DialogTitle id="logout-dialog-title">
          {t('Logout')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('Are you sure you want to log out?')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onConfirm}
            color="primary"
            className="logout-dialog-confirm-button"
          >
            {t('Yes')}
          </Button>
          <Button
            onClick={onClose}
            className="logout-dialog-cancel-button"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(LogoutDialog);
